<div class="mt-5">
    <div class="flex justify-content-between">

        @if(is_already_approved){
        <div class="font-bold text-green-500  text-lg">
            {{'initiative_approved' | translate}}
        </div>
        }
        @else {
        @if(is_complete_status && !is_allowed_to_submit){
        <div class="font-bold text-green-500  text-lg">
            {{'initiative_under_review' | translate}}
        </div>
        }

        @if(!is_complete_status){
        <div class="font-bold text-lg text-red-500">
            {{'initiative_not_valid' | translate}}
        </div>
        }

        @if(is_complete_status&&is_allowed_to_submit){
        <div class="font-bold text-green-500  text-lg">
            {{'initiative_valid_for_evaluation' | translate}}
        </div>
        }
        }
    </div>
    <div class="mt-5">
        <p-timeline [value]="completionStatus" class="md:w-10rem" [align]="dir==='rtl'?'rigth':'left'">
            <ng-template pTemplate="marker" let-status>

                @if(status.isComplete){
                <span
                    class="flex w-2rem h-2rem  bg-green-500 align-items-center justify-content-center text-white border-circle z-1 shadow-1">
                    <i [class]="'pi pi-check'"></i>
                </span>

                }@else{
                <span
                    class="flex w-2rem h-2rem   bg-red-500  align-items-center justify-content-center text-white border-circle z-1 shadow-1">
                    <i [class]="'pi pi-times'"></i>
                </span>

                }
            </ng-template>
            <ng-template pTemplate="content" let-statusContent>
                <div>
                    <div class="font-bold text-xl g-c-brown-color">
                        {{ dir == 'rtl' ? statusContent.name_ar : statusContent.name_en }}
                    </div>

                    @if(statusContent.children?.length)
                    {
                    @for(child of statusContent.children;track child ){

                    @if(child.isComplete){
                    <div class="my-3   text-green-500  font-bold">
                        {{ dir == 'rtl' ? child.name_ar : child.name_en }}
                    </div>
                    }@else{
                    <div class="my-3   text-red-500  font-bold">
                        {{ dir == 'rtl' ? child.name_ar : child.name_en }}
                    </div>
                    }
                    }
                    }

                </div>
            </ng-template>
        </p-timeline>
    </div>
    @if(isSuccessModalVisible){

    <app-success-modal message="نجح تقديم الطلب"></app-success-modal>
    }
</div>